import React from 'react'
import { twMerge } from 'tailwind-merge'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'
import { Menu } from 'lucide-react'

const VerticalNavTabs = ({ className, children, theme }) => {
  const navLinks = React.Children.toArray(children).filter(Boolean)

  return (
    <>
      {/* Mobile Dropdown Menu */}
      <div className={twMerge('md:hidden', className)}>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className='p-2 m-5 border rounded-md flex items-center gap-2'>
              <Menu size={20} />
              <span className='text-sm'>Menu</span>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align='start'>
            {navLinks.map((child, index) => (
              <DropdownMenuItem key={index} asChild>
                {React.cloneElement(child, { theme })}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      {/* Desktop Vertical Nav */}
      <div className={twMerge('hidden md:flex flex-col shrink-0 space-y-1 min-w-48 h-full pt-5 px-5 border-r border-border max-w-[250px]', className)}>
        {
          React.Children.map(children, child => {
            if (!child) return null
            return React.cloneElement(child, { theme })
          })
        }
      </div>
    </>
  )
}

export default VerticalNavTabs
